/**
 * Dashboard Preferences Types
 *
 * Defines section visibility preferences for admin dashboards.
 * Preferences are stored in localStorage for persistence.
 */
export const DEFAULT_SECTION_VISIBILITY = {
    stats: true,
    charts: true,
    criticalActions: true,
    highPriorityActions: true,
    mediumActions: true,
    pendingApprovals: true
};
export const DEFAULT_PREFERENCES = {
    sectionVisibility: DEFAULT_SECTION_VISIBILITY,
    lastUpdated: new Date().toISOString()
};
export const STORAGE_KEYS = {
    FINANCIAL_DASHBOARD: 'dashboard-prefs-financial',
    INVENTORY_DASHBOARD: 'dashboard-prefs-inventory'
};
export const FINANCIAL_DASHBOARD_SECTIONS = [
    { key: 'stats', label: 'Statistics Cards', description: 'Key metrics at a glance' },
    { key: 'charts', label: 'Charts', description: 'Cash flow and aging analysis' },
    { key: 'criticalActions', label: 'Critical Actions', description: 'Urgent items requiring attention' },
    { key: 'highPriorityActions', label: 'High Priority', description: 'Important upcoming actions' },
    { key: 'mediumActions', label: 'Upcoming', description: 'Standard priority items' },
    { key: 'pendingApprovals', label: 'Pending Approvals', description: 'Items awaiting approval' }
];
export const INVENTORY_DASHBOARD_SECTIONS = [
    { key: 'stats', label: 'Statistics Cards', description: 'Inventory metrics at a glance' },
    { key: 'charts', label: 'Charts', description: 'Shape and aging distribution' },
    { key: 'criticalActions', label: 'Critical Actions', description: 'Slow-moving inventory' },
    { key: 'highPriorityActions', label: 'High Priority', description: 'High-value items' },
    { key: 'mediumActions', label: 'Medium Priority', description: 'Low-margin items' },
    { key: 'pendingApprovals', label: 'Low Priority', description: 'Items missing certificates' }
];
